export default __webpack_public_path__ + "static/media/sinexito.99c22df2.png";